import { GlobalConfig } from 'ngx-toastr';

export const lightToastConfig: Partial<GlobalConfig> = {
  closeButton: true,
  tapToDismiss: true,
  newestOnTop: true,
  preventDuplicates: true,
  maxOpened: 4,
  autoDismiss: false,
  progressBar: false,
  positionClass: 'toast-top-center',
  timeOut: 2600,
  extendedTimeOut: 1200,
  toastClass: 'ngx-toastr toast-lite'
};
